module.exports = function() {
  return new Worker(__webpack_public_path__ + "587d82d11b9491ab6337.worker.js");
};